import { render, staticRenderFns } from "./PwdStep1Cmp.vue?vue&type=template&id=05bed604&"
import script from "./PwdStep1Cmp.vue?vue&type=script&lang=js&"
export * from "./PwdStep1Cmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports